import React from 'react'
import AppContext from 'AppContext'
import { featureEnabled, env } from 'components/Helpers'
import { NotEnabledPage } from 'scenes/NotEnabled'

const Leads = ({ match }) => {
  const token = window.localStorage.getItem('auth-token')
  const { operator: { id, locales } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index sales-promotions'>
        <p>waiting for operator...</p>
      </div>
    )
  }

  if (!featureEnabled('leads', id)) {
    return (<NotEnabledPage />)
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index sales-promotions'>
      {/* eslint-disable-next-line */}
      <h1></h1>
      <cl-leads
        mountPath={`/operators/${id}/leads`}
        apiHost={`https://leads.${env()}.credlock.net`}
        operatorId={id}
        token={token}
        locales={locales}
      />
    </div>
  )
}

export default Leads
